import { useToast } from '@chakra-ui/react';
import { useState } from 'react';

import apiService from 'services';
import { getOriginalDownloadExtension } from 'utils/dataSourceDownload';

/** Downloads a stored version from the server, saving it under `<source> - <version>.<ext>`. */
const useVersionDownload = (dataSourceId: number | undefined, sourceName: string | undefined) => {
  const toast = useToast();
  const [downloadingId, setDownloadingId] = useState<number | null>(null);

  const download = async (version: any, format: 'original' | 'csv' = 'original') => {
    if (!dataSourceId || !version?.id) return;
    setDownloadingId(version.id);
    try {
      const response = await apiService.downloadVersionFile(dataSourceId, version.id, { format });
      const extension =
        format === 'original' ? getOriginalDownloadExtension(version.storage_format) : 'csv';
      const mimeType =
        extension === 'parquet' ? 'application/vnd.apache.parquet' : 'text/csv;charset=utf-8';
      const url = URL.createObjectURL(new Blob([response.data], { type: mimeType }));
      const link = document.createElement('a');
      link.href = url;
      link.download = `${sourceName ?? 'source'} - ${version.name}.${extension}`;
      document.body.append(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error: any) {
      toast({
        title: 'Download failed',
        description:
          error?.response?.data?.message || 'Could not download this version. Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setDownloadingId(null);
    }
  };

  return { download, downloadingId };
};

export default useVersionDownload;
